export default __webpack_public_path__ + "static/media/image.dhan-solutions-private-limited.10fbec0c.png";